// extracted by mini-css-extract-plugin
export const stack = "stack-module--stack--2zm15";
export const item = "stack-module--item--NLJ2B";
export const isSelected = "stack-module--isSelected--Mr1UX";